<!-- eslint-disable max-len -->
<template>
  <!-- eslint-disable max-len -->
  <div>
    <div class="bg-blue-800 h-full w-full">
      <div class="container mx-auto px-4 h-full pt-24 min-h-screen">
        <div class="flex content-center items-center justify-center h-full">
          <div class="w-full lg:w-7/12 px-4">
            <div
              class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-100 border-0"
            >
              <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
                <div class=" mb-3">
                  <img class="m-auto" src="@/assets/musicverse-logo.png" style="width: 150px"/>
                </div>
                <h6 class="font-bold text-center mb-8 text-3xl">Thank you!</h6>
                <p class="text-left">
                  We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link.<br/><br/>
                  If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.<br/><br/>
                  If you still didn't receive the confirmation email to <span class="font-bold">{{ this.email }}</span> , click <a class="text-blue-600 cursor-pointer font-bold" @click="nextProcess" >here</a> to resend.
                </p>
                <p class="text-left mt-6">
                  Your artist application has been submitted and is now <span class="font-bold">pending admin review</span>. Once you verify your email, our team will review your application and follow up with the next steps.
                </p>
                <alert variant="danger" class="mt-4" v-if="error">
                  Sorry! {{error}}
                </alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isEmailHasBeenSend" class="fixed top-0 mt-8 w-full p-2 md:p-0 flex justify-center" @click="toggleToast()" >
      <input type="checkbox" class="hidden" id="footertoast" >

      <label class="close cursor-pointer flex items-start justify-between w-full md:w-1/2  p-2 bg-green-500 rounded shadow-lg text-white" title="close" for="footertoast">
        Email has been sent

        <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </label>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Alert from '@/components/Layout/Alert';
export default {
  name: 'SignupSuccess',
  data: () => ({
    isEmailHasBeenSend: false,
    message: '',
    error: null,
  }),
  props: {
    email: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
  },
  methods: {
    ...mapActions('EmailModule', ['requestResendVerification']),
    async nextProcess() {
      try {
        await this.requestResendVerification(this.email);
        this.isEmailHasBeenSend = true;
        setTimeout(this.toggleToast, 2000);
      } catch (err) {
        this.error = err.message;
      }
    },
    toggleToast() {
      this.isEmailHasBeenSend = !this.isEmailHasBeenSend;
    },
  },
  components: { Alert },
};
</script>



// WEBPACK FOOTER //
// src/views/SignupSuccess.vue